import enLang from './entries/en-US';
import koLang from './entries/ko_KR';
import jaLang from './entries/ja_JP';

const AppLocale: any = {
  en: enLang,
  ja: jaLang,
  ko: koLang,
};

export default AppLocale;
